import { apiAxios, V3_API_END_POINT } from '../config/axios';

export const OfferService = {
  async getTotalOfferTried() {
    const res = await apiAxios.get('/user_offer/total_offers/me');
    return res.data;
  },
  async getTotalOfferCompleted() {
    const res = await apiAxios.get(
      `${V3_API_END_POINT}/offer/reward/completed/count`
    );
    return res.data;
  },
};
